<template lang="pug">
#bet-status-single-mmo.modal.modal-bottom.fade.modal-bet-status(tabindex='-1' role='dialog' aria-labelledby='bet-status' aria-hidden='true')
  .modal-dialog.modal-dialog-scrollable.m-0(role='document')
    .modal-content
      .modal-body.p-0
        template(v-if="response && response.success")
          .bet-slip
            .stake-info-wrapper
              .bet-status(:class="status ? 'waiting' : (betStatus === 'REJECT') ? 'reject' : 'confirm'")
                span {{ status ? $t('ui.waiting') : (betStatus === 'REJECT') ? $t('ui.reject') : $t('ui.confirm') }}
                template(v-if="status")
                  span.mr-1(v-if="counter > 0") &nbsp;({{ counter + 's' }})
                  span.mr-1(v-else) &nbsp;
                    i.fa.fa-spin.fa-spinner
              .bet-league
                img.icon(:src="'/images/icon-sport-svg/' + getSportsImage(betsinglemmo.sportsType)")
                template(v-if="racingList.includes(betsinglemmo.sportsType)")
                  span {{ sports[betsinglemmo.sportsType] }}
                template(v-else)
                  span {{ sports[betsinglemmo.sportsType] }} - {{ betTypeDisplay }}
              .stake-info
                .betslip-match
                  .team-involved
                    template(v-if="racingList.includes(betsinglemmo.sportsType)")
                      span {{ betsinglemmo.homeName }}
                      span.small.ml-1(v-if="[49, 51].includes(betsinglemmo.sportsType) && betsinglemmo.matchTime") (No. {{ $dayjs(betsinglemmo.matchTime).format("MMDDhhmm") }})
                    template(v-else)
                      .score(v-if="betsinglemmo.marketType == 3 && betsinglemmo.score != ''") {{ betsinglemmo.score }}
                      span(:class="betsinglemmo.giving == 1 && isBallDisplay ? 'team2' : 'team1'") {{ betsinglemmo.homeName }}
                      span.vs(v-if="betsinglemmo.betType != 'OR'") - VS -
                      span(:class="betsinglemmo.giving == 0 && isBallDisplay ? 'team2' : 'team1'" v-if="betsinglemmo.betType != 'OR'") {{ betsinglemmo.awayName }}
                .selector-odd.d-flex.justify-content-between
                  template(v-if="racingList.includes(betsinglemmo.sportsType)")
                    span.bet-type-text(v-if="['OU','OE'].includes(betsinglemmo.betType)") {{ $t("m.GH_" + betsinglemmo.betDisplay.toUpperCase()) }}
                    span.bet-type-text(v-else) {{ $t("m.GH_" + betsinglemmo.betType + (betsinglemmo.ballDisplay == undefined ? '' : betsinglemmo.ballDisplay)) }}
                    .bet-type-odds
                      .odds
                        span(:class="{ 'negetive' : betsinglemmo.val < 0 }") {{ betsinglemmo.val }}
                  template(v-else)
                    span.text(:class="isBallDisplay == false ? '' : ((betsinglemmo.giving == 0 && betsinglemmo.homeAway == 2) ? 'team2' : (betsinglemmo.giving == 1 && betsinglemmo.homeAway == 1) ? 'team2' : 'team1')") {{ betsinglemmo.betType }} | {{ betsinglemmo.betDisplay }}
                    .bet-type-odds
                      template(v-if="betsinglemmo.fact.ball_display < 0")
                        span.negetive {{ betsinglemmo.fact.ball_display }}
                      template(v-else)
                        span {{ betsinglemmo.fact.ball_display }}
                      template(v-if="betsinglemmo.fact.criteria2 < 0")
                        span.mr-1.negetive ({{ betsinglemmo.fact.criteria2 }})
                      template(v-else)
                        span.mr-1 ({{ betsinglemmo.fact.criteria2 }})
                      .odds
                        span(:class="{ 'negetive' : betsinglemmo.val < 0 }") {{ betsinglemmo.val }}
              .payout-wrapper
                .left {{ $t("ui.stake")}}: {{ $numeral(betsinglemmo.stake).format("0,0.00[0]") }}
                .right {{ $t("ui.payout")}}: {{ $numeral(betsinglemmo.payout).format("0,0.00[0]") }}
          .btn-continue(@click="hideMe()") {{ $t("ui.continue_bet") }}
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import config from "@/config";
import naming from "@/library/_name";
import xhr from "@/library/_xhr-betmmo.js";

export default {
  components: {},
  data() {
    return {
      betsinglemmo: {},
      items: [],
      response: null,
      status: false,
      betStatus: "",
      checkCounter: null,
      counter: 5
    };
  },
  computed: {
    racingList() {
      return config.racingList;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    isBallDisplay() {
      // var result = naming.ballDisplay2(this.betsinglemmo.ballOrigin, this.betsinglemmo.giving, this.betsinglemmo.homeAway, this.betsinglemmo.betType, this);
      var result = naming.ballDisplay2(this.betsinglemmo.fact.ball_display, this.betsinglemmo.giving, this.betsinglemmo.homeAway, this.betsinglemmo.betType, this);
      if (["HDP", "HDPH"].includes(this.betsinglemmo.betType)) {
        return result != null && result != "0";
      } else {
        return false;
      }
    },
    betTypeDisplay() {
      return this.$t("m.BS_" + this.betsinglemmo.betType);
    },
    commType() {
      return this.$store.getters.commType;
    },
    menu4() {
      return this.$store.getters.menu4;
    },
    debug() {
      return config.debugMode;
    },
    pageDisplay() {
      return this.$store.getters.pageDisplay;
    },
    betting() {
      return this.$store.getters.betting;
    },
    currencyCode() {
      return this.$store.getters.currencyCode.replace('UST', 'USDT');
    },
    isDataExists() {
      if (this.betsinglemmo.hasOwnProperty("val")) {
        return true;
      } else {
        return false;
      }
    },
    sports() {
      return this.$store.state.layout.sports;
    }
  },
  destroyed() {},
  mounted() {
    EventBus.betSingleStatusMMO = this.runbet;
    $("#bet-status-single-mmo").on("hidden.bs.modal", () => {
      var _this = this;
      clearInterval(_this.checkCounter);
    });
  },
  methods: {
    getSportsImage(e) {
      return config.getSportsImage(e);
    },
    runbet(e, f) {
      this.betsinglemmo = e;
      this.response = f;
      this.status = f.data.pending;
      this.showMe();
    },
    showMe() {
      $("#bet-status-single-mmo").modal("show");
      this.betStatus = "";
      if(this.status) {
        this.checkCounter = setInterval(this.handleCounter, 1000);
      }
    },
    hideMe() {
      $("#bet-status-single-mmo").modal("hide");
      clearInterval(this.checkCounter);
    },
    handleCounter() {
      if(this.counter > 0) {
        this.counter -= 1;
      } else {
        this.populateList();
        this.counter = 5;
      }
    },
    populateList(callback) {
      if (this.isLoggedIn) {
        this.loading = true;
        var args = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          bet_id: this.response.data.betId,
          bet_type: this.betsinglemmo.betType == "HDP" ? "HDPMMO" : "OUMMO"
        };
        xhr.betStatus(args).then(
          res => {
            this.loading = false;
            if (res.success) {
              if (res.data) {
                var betId = res.data[0].bet_id;
                this.betStatus = res.data[0].bet_status;
                this.status = res.data[0].bet_status === 'PENDING';
                if(this.betStatus != 'PENDING') {
                  clearInterval(this.checkCounter);
                }
                if (callback) callback();
              }
            } else {
              if (this.$helpers.handleFeedback(res.status)) {
                if (callback) callback();
              }
            }
          },
          err => {
            this.loading = false;
            if (this.$helpers.handleFeedback(err.status)) {
              if (callback) callback();
            }
          }
        );
      }
    }
  }
};
</script>
